
import { ref } from '@nuxtjs/composition-api'
import { commonInputAttrs } from './shared'
import useTracking from '~/composable/tracking/useTracking'

export default {
  props: {
    label: {
      type: String,
      default: '',
      required: true
    },
    requiredText: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const { trackFieldRule, trackFieldError } = useTracking()

    const fieldRules = [
      v => !!v || trackFieldRule({ message: props.requiredText || 'Du skal skrive ' + props.label.toLowerCase(), fieldName: 'password' })
    ]

    const show = ref(false)

    return {
      trackFieldError,
      show,
      commonInputAttrs,
      fieldRules
    }
  }
}
